import React from 'react';
import type { PlanStep } from '../../types/agent.types';

interface ValidateButtonProps {
  steps: PlanStep[];
  isValidating: boolean;
  onValidate: () => void;
}

export const ValidateButton: React.FC<ValidateButtonProps> = ({
  steps,
  isValidating,
  onValidate,
}) => {
  // Treat undefined/null review_status as 'pending' (defense-in-depth —
  // backend now sets 'pending' at creation, but older plans may lack it)
  const pendingSteps = steps.filter((s) => !s.review_status || s.review_status === 'pending');
  const approvedSteps = steps.filter((s) => s.review_status === 'approved');
  const modifiedSteps = steps.filter((s) => s.review_status === 'modified');
  const refusedSteps = steps.filter((s) => s.review_status === 'refused');

  const allReviewed = pendingSteps.length === 0;
  const allRefused = refusedSteps.length === steps.length;

  const getButtonLabel = () => {
    if (isValidating) return '';
    if (allRefused) return 'Refuser ce plan';
    return 'Valider ce plan d\'action';
  };

  const getButtonClass = () => {
    if (isValidating) return 'agent-validate-btn agent-validate-btn--loading';
    if (!allReviewed) return 'agent-validate-btn agent-validate-btn--disabled';
    if (allRefused) return 'agent-validate-btn agent-validate-btn--refuse';
    return 'agent-validate-btn agent-validate-btn--enabled';
  };

  const getSubtext = () => {
    if (!allReviewed) {
      return {
        text: `${pendingSteps.length} etape${pendingSteps.length > 1 ? 's' : ''} en attente de revue`,
        className: 'agent-validate-subtext agent-validate-subtext--warning',
      };
    }
    const parts: string[] = [];
    if (approvedSteps.length > 0) parts.push(`${approvedSteps.length} approuvee${approvedSteps.length > 1 ? 's' : ''}`);
    if (modifiedSteps.length > 0) parts.push(`${modifiedSteps.length} modifiee${modifiedSteps.length > 1 ? 's' : ''}`);
    if (refusedSteps.length > 0) parts.push(`${refusedSteps.length} refusee${refusedSteps.length > 1 ? 's' : ''}`);
    return {
      text: parts.join(', '),
      className: 'agent-validate-subtext',
    };
  };

  const subtext = getSubtext();

  return (
    <div>
      <button
        className={getButtonClass()}
        disabled={!allReviewed || isValidating}
        onClick={onValidate}
      >
        {isValidating ? (
          <span className="agent-spinner" />
        ) : (
          <>
            {!allRefused && allReviewed && (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            )}
            {getButtonLabel()}
          </>
        )}
      </button>
      <div className={subtext.className}>{subtext.text}</div>
    </div>
  );
};
